import React from 'react';
import styled from 'styled-components';
import HeartIcon from '@material-ui/icons/Favorite';
import CoffeeIcon from '@material-ui/icons/LocalCafe';

function Footer() {
  return (
    <FooterStyled>
      <p>
        &copy;2021 Made with <HeartIcon className="icon-he" /> and <CoffeeIcon className="icon-cf" /> by Pedro Gonçalves
      </p>
    </FooterStyled>
  );
}

const FooterStyled = styled.footer`
  width: 100%;
  padding: 1rem 0;
  font-size: 1.1rem;
  text-align: center;
  border-top: 1pxsolidvar (--border-color);
  background-color: var(--background-dark-grey);
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid var(--border-color);

  @media screen and (max-width: 1100px) {
    width: 100%;
    margin-left: 0;
  }

  .icon-he {
    font-size: 1.1rem;
    color: #ff0000;
  }

  .icon-cf {
    font-size: 1.1rem;
    color: #03615c;
  }
`;

export default Footer;
